export enum TextViewerFontFamilyType {
  Gothic = 'Gothic',
  Batang = 'Batang',
  Myeongjo = 'Myeongjo',
}
